var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('TransactionListTemplate',{ref:"awaiting-payment-list",attrs:{"screenConfig":_vm.setScreenConfig,"setLoading":_vm.setLoading,"persistenceKey":'awaiting-payments',"gcPopupConfig":_vm.gcPopupConfig}})}
var staticRenderFns = []

export { render, staticRenderFns }